export default "__VITE_ASSET__D70zlS6A__"